<template>
  <a-layout class="admin-layout">
    <a-layout-sider v-model="collapsed" collapsible width="180px" class="admin-slider">
      <div class="admin-sider-inner">
        <div class="logo" :style="collapsed ? 'margin:8px 24px' : 'margin:8px 14px'">
          <img width="25px" src="@/assets/logo.svg" />
          <p>Boss Admin</p>
        </div>
        <div class="admin-sider-menu-scroll beauty-scroll">
          <a-menu theme="dark" mode="inline"
              :open-keys="openKeys"
              :default-selected-keys="['/workplace']"
              :selectedKeys="selectedKeys"
              :getPopupContainer="menuGetPopupContainer"
              @openChange="onOpenChange"
          >
        <a-menu-item key="/workplace">
          <router-link to="/workplace">
            <a-icon type="fund" />
            <span>{{ $t('menu.workplace') }}</span>
          </router-link>
        </a-menu-item>
        <template v-for="item in menuList">
          <template v-if="item.children">
            <a-sub-menu v-if="!item.meta.invisible" :key="item.path">
              <span slot="title">
                <a-icon :type="item.meta.icon" />
                <span>{{ (item.meta && item.meta.title) ? $t(item.meta.title) : item.name }}</span>
              </span>
              <template v-for="subItem in item.children">
                <a-menu-item v-if="!subItem.meta || !subItem.meta.invisible" :key="subItem.path">
                  <router-link :to="subItem.path">
                    {{ (subItem.meta && subItem.meta.title) ? $t(subItem.meta.title) : subItem.name }}
                  </router-link>
                </a-menu-item>
              </template>
            </a-sub-menu>
          </template>
          <template v-else>
            <template v-if="!item.meta || !item.meta.invisible">
              <a-menu-item :key="item.path">
                <router-link :to="item.path">
                  <a-icon :type="item.meta.icon" />
                  <span>{{ (item.meta && item.meta.title) ? $t(item.meta.title) : item.name }}</span>
                </router-link>
              </a-menu-item>
            </template>
          </template>
        </template>
          </a-menu>
        </div>
      </div>
    </a-layout-sider>
    <a-layout class="beauty-scroll">
      <a-layout-header class="admin-header">
        <div class="bread-crumb">
          <a-breadcrumb style="margin:0 16px">
            <a-breadcrumb-item v-for="(item, index) in breadList" :key="index">
              {{ (item.meta && item.meta.title) ? $t(item.meta.title) : item.name }}
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
        <div class="admin-header-menu">
          <a-dropdown class="header-item" placement="bottomRight">
            <span>{{ adminInfo.username }}</span>
            <a-menu slot="overlay" style="width:140px;">
              <a-menu-item @click="setting">
                <a-icon type="setting" />
                <span>设置</span>
              </a-menu-item>
              <a-menu-item @click="logout">
                <a-icon style="margin-right: 8px;" type="poweroff" />
                <span>退出</span>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-layout-header>
      <a-layout-content :style="{minHeight:'280px'}">
        <router-view />
        <div style="width:100%; height:60px;"></div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import store from '@/store';
import {adminInfo, logout} from '@/api/app';

export default {
  provide() {
    return {
      adminLayout: this
    }
  },
  data() {
    return {
      adminInfo: {
        id: 0,
        username: ''
      },
      collapsed: false,
      menuList: [],
      rootSubmenuKeys: [],
      openKeys: [],
      selectedKeys: [],
      breadList: []
    };
  },
  watch: {
    '$route'() {
      this.updateMenu();
      this.getBreadcrumb();
    }
  },
  mounted() {
    this.updateMenu();
  },
  created() {
    // 管理员信息
    if(store.state.admin.adminInfo.username == undefined) {
      adminInfo().then(res=>{
        store.commit('admin/setAdminInfo', res.data.adminInfo);
        this.adminInfo = {...res.data.adminInfo};
      });
    } else {
      const adminInfo = store.state.admin.adminInfo;
      this.adminInfo = {...adminInfo};
    }

    // 设置同时只能展开一组菜单
    this.menuList = store.state.admin.menus;

    let keys = [];
    this.menuList.forEach(function(value){
      if(value.children && value.children.length > 0) {
        keys.push(value.path);
      }
    });
    this.rootSubmenuKeys = keys;

    this.getBreadcrumb();
  },
  methods: {
    /** 折叠侧栏时子菜单以弹出层展示，挂到 body 避免被侧栏 overflow 裁切或挡住主菜单 */
    menuGetPopupContainer() {
      return document.body;
    },
    menuName(item) {
      return item.name;
    },
    setting() {
      this.$router.push('/setting');
    },
    logout() {
      logout();
      this.$router.push('/login');
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
      if(this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    updateMenu () {
      const routes = this.$route.matched.concat();
      this.selectedKeys = [ routes.pop().path ];
    },
    getBreadcrumb() {
      let matched = this.$route.matched;
      this.breadList = matched;
    }
  }
};
</script>

<style lang="less" scoped>
.admin-layout {
  height: 100vh;

  .logo {
    height: 32px;
    line-height: 32px;
    font-size: 20px;
    color: #fff;
    overflow: hidden;

    img {
      vertical-align: middle;
    }
    p {
      display: inline-block;
      padding: 0 10px;
      font-weight: 600;
    }
  }

  .admin-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background:#fff;
    margin: 8px 16px 0 16px;
    padding: 0;
    z-index: 2;
    height: 42px;
    line-height: 42px;

    .bread-crumb {
      display: flex;
      background: #fff;
    }

    .admin-header-menu {
      display: flex;
      padding: 0 12px;

      .header-item {
        color: inherit;
        padding: 0 12px;
        cursor: pointer;
        align-self: center;

        &:hover {
          background-color: #f8f8f8;
        }
      }
    }
  }
}

</style>

<style lang="less">
/*
 * 侧栏：子菜单多时仅菜单区滚动。
 * ant-layout-sider-trigger 为 position:fixed 贴底，若整栏滚动/高度链不对，底部项会被挡住。
 */
.admin-layout.ant-layout-has-sider > .ant-layout-sider.admin-slider {
  height: 100vh;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.admin-layout.ant-layout-has-sider > .ant-layout-sider.admin-slider .ant-layout-sider-children {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: auto !important;
  overflow: hidden;
}

.admin-layout .admin-sider-inner {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-layout .admin-sider-menu-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  /* 折叠触发条高度 48px + 少量余量，避免最后一项被 fixed 触发条盖住 */
  padding-bottom: 52px;
}

/* 折叠后 SubMenu 弹出层在 body 上，保证浮在内容区之上且不被侧栏裁切 */
.ant-menu-submenu-popup.ant-menu-dark,
.ant-menu-submenu-popup {
  z-index: 1100 !important;
}
</style>